import { HttpContextToken } from '@angular/common/http';

export const EXCLUDE_EXPIRED = new HttpContextToken<boolean>(() => false);
